<template>
  <div>
    <v-progress-linear absolute indeterminate :active="loading">
    </v-progress-linear>
    <v-data-table
      v-show="!error"
      :headers="headers"
      :items="items"
      :items-per-page="10"
    >
      <template v-slot:item.message="{ item }">
        <span>
          {{ shortMessage(item.message) }}
        </span>
      </template>

      <template v-slot:item.date_notification="{ item }">
        <span>
          {{ item.date_notification }}
        </span>
      </template>

      <template v-slot:item.viewed="{ item }">
        <v-chip small color="green" v-if="item.viewed == '1'">{{
          $t("read")
        }}</v-chip>
        <v-chip small color="red" v-else>{{ $t("notRead") }}</v-chip>
      </template>

      <template v-slot:item.id="{ item }">
        <v-btn @click="openMessageDetail(item.id)">
          <v-icon>mdi-magnify-plus-outline</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog
      v-model="detail"
      max-width="650"
      scrollable
      :retain-focus="false"
      persistent
    >
      <v-card>
        <v-toolbar>
          <v-toolbar-title>{{ $route.meta.nameDrawer }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeMessageDetail"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-toolbar>
        <MessageDetail v-if="detail" :messageId="currentMessageId" />
      </v-card>
    </v-dialog>

    <v-card-text class="text-center" v-if="error">
      <div>{{ $t("noNewMessagesAtMoment") }}</div>
    </v-card-text>
  </div>
</template>
<script>
import MessageDetail from "./messageDetail.vue";

export default {
  data: () => ({
    currentMessageId: 0,
    loading: false,
    detail: false,
    error: false,
    items: [],
    // headers: [],
    msgMock: [{
      "messages": "",
      "dados": {
        "id": "1186",
        "message": "Ola, foram modificados alguns parametros que podem afetar futuras apostas, segue as modificacoes: multiplicador maximo na aposta: 100,00.",
        "date_notification": "2024-05-23"
      }
    }]
  }),
  components: { MessageDetail },
  computed: {
    headers() {
      return [
        {
          text: this.$t("date"),
          value: "date_notification",
          sortable: true,
        },
        {
          text: this.$t("message"),
          value: "message",
        },
        {
          text: this.$t("read"),
          value: "viewed",
          sortable: true,
        },
        {
          text: this.$t("listBetOnlineHeaderAction"),
          value: "id",
          sortable: false,
        },
      ];
    },
  },
  mounted() {
    this.lastNotifications();
  },

  methods: {
    openMessageDetail(currentMessageId) {
      this.currentMessageId = currentMessageId;
      this.detail = true;
    },
    closeMessageDetail() {
      this.detail = false;

      this.items = this.items.map((item) => {
        if (item.id == this.currentMessageId && item.viewed == "0") {
          this.$store.commit(
            "setMessagesNotRead",
            this.$store.state.messagesNotRead - 1
          );
          return { ...item, viewed: 1 };
        }

        return item;
      });

      this.currentMessageId = 0;
    },
    shortMessage(message) {
      return message.substring(0, 50) + "...";
    },
    lastNotifications() {
      this.loading = true;
      this.$axios
        .get("/player/notifications/list")
        .then((resp) => {
          if (resp.status === 200) {
            this.items = resp.data.dados;
            let notRead = 0;

            this.items.forEach((item) => {
              notRead += item.viewed == "0" ? 1 : 0;
              item.date_notification = new Date(
                item.date_notification
              ).toLocaleString();
            });

            this.$store.commit("setMessagesNotRead", notRead);
            this.error = false;
          }
        })
        .catch((err) => {
          if (err.response.data.status === 400) {
            this.error = true;
            const color = "warning";
            const msg = err.response.data.messages.error;
            this.$store.commit("setNotification", { msg, color });
          }
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
